import { VesselCategories, VesselPositionDataExtended } from "../services/types/position-service.types";
import { ForecastMetadata } from "../services/weather-service";
import { BaseModel } from "./base-model";

export const weatherElements: string[] = ["Wind50M", "WindGusts50M", "RiskWaveHeight", "WavePeriod", "SwellPeriod", "Wave", "Swell", "Currents"];
// interface and weather elements should always match
export interface PastTrailData {
    timestamp: string;
    latitude: string|null;
    longitude: string|null;
    heading: number|null;
    course: number|null;
    draft?: number|null;
    navigationalStatus?: string|null;
    speed: number|null;
    source: string;
    wind50M?: string, 
    windGusts50M?: string,
    riskWaveHeight?: string,
    wave?: string, 
    swell?: string,
    weatherForecast?: ForecastMetadata,
    positionData: VesselPositionDataExtended,
    currents?: string
}

export enum VoyagePastTrailModelEvents {
    TrackUpdated = 'track-updated',
    RowFocused="row-position-focused",
    RowSelected="row-position-selected",
    PastTrailClicked="past-trail-clicked"
}

export enum HighlightPastTrailActions {
        Focus="focus",
        Click="click" 
}

export abstract class VoyagePastTrailModelBase extends BaseModel {
    abstract createPastTrailSegment(imo: number, fromDate: number, toDate: number): void;
    abstract highlightPastTrailPoint(dp:any, action:string): void;
    abstract highlightTableOnPastTrailClick(dp:any): void;
    abstract get trackSegment(): PastTrailData[];
    abstract get loadingPastTrailPromise(): Promise<void> | undefined;
    abstract fetchWeather(): void;
    abstract fetchWeatherSinglePosition(position: PastTrailData): Promise<PastTrailData>;
    abstract hasWeather(): boolean;

}

let VoyagePastTrailModel: VoyagePastTrailModelBase|null = null;

function setVoyagePastTrailModel(model: VoyagePastTrailModelBase) {
    VoyagePastTrailModel = model;
}

export { VoyagePastTrailModel, setVoyagePastTrailModel };
